export enum FormaPagamentoEnum {
    CARTAO_CREDITO = "1",
    DEBITO_CONTA = "3"
}